import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { pathFinder } from '../ui/pathFinder-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { createTask_putOnSuit } from './taskPutOnSuit'
import { createTask_goToMachine } from './taskGoToMachine'

export function createTask_exitShip(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'exit-ship', {})
}

export function runTask_exitShip(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'exit-ship')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (!m.isInsideShip) {
    // We are already outside!
    return jobLogger.succeedTask(job, task)
  }

  if (m.data.needsSuit && !m.isInSuit) {
    // Put on suit!
    task.subtasks.push(createTask_putOnSuit(m.i, m.j))
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  let f = (c: IMachine) => c.data.type === 'airlock2'
  if (machines.findAtSpot(m.i, m.j, f)) {
    // Here!
    monsters.setInsideOutside(m, false)
    return jobLogger.succeedTask(job, task)
  }

  // Add move to machine task
  task.subtasks.push(createTask_goToMachine(m.i, m.j, f))
}
